module.exports = __webpack_public_path__ + "static/img/hpc-logo.b373c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hpc-logo.jpg
// module id = bpAb
// module chunks = 3